import RangeInput from './range';

export { RangeInput };
